var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSla = function SvgSla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sla_svg2__a",
    x1: -28.06,
    x2: 151.53,
    y1: 162.14,
    y2: -2.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__b",
    x1: -43.68,
    x2: 135.89,
    y1: 145.07,
    y2: -19.26
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__c",
    x1: -55.7,
    x2: 123.88,
    y1: 131.94,
    y2: -32.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__d",
    x1: -41.53,
    x2: 138.04,
    y1: 147.42,
    y2: -16.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__e",
    x1: -20.06,
    x2: 159.52,
    y1: 170.89,
    y2: 6.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__f",
    x1: -21.38,
    x2: 158.2,
    y1: 169.44,
    y2: 5.11
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__g",
    x1: -24.86,
    x2: 154.71,
    y1: 165.64,
    y2: 1.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__h",
    x1: -3.38,
    x2: 176.19,
    y1: 189.11,
    y2: 24.78
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__i",
    x1: -4.71,
    x2: 174.87,
    y1: 187.66,
    y2: 23.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__j",
    x1: -8.33,
    x2: 171.25,
    y1: 183.71,
    y2: 19.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__k",
    x1: 11.83,
    x2: 191.41,
    y1: 205.73,
    y2: 41.4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__l",
    x1: 8.21,
    x2: 187.79,
    y1: 201.78,
    y2: 37.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__m",
    x1: 28.37,
    x2: 207.94,
    y1: 223.8,
    y2: 59.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__n",
    x1: -4.47,
    x2: 175.11,
    y1: 187.92,
    y2: 23.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sla_svg2__a",
    id: "sla_svg2__o",
    x1: 49.21,
    x2: 228.79,
    y1: 246.58,
    y2: 82.25
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m101.78 45.9 1.64-4.3h11.16l1.62 4.29c.44 1.17 1.56 1.9 2.74 1.9a2.938 2.938 0 0 0 2.74-3.97l-9.38-24.84s-.02-.05-.03-.08a3.48 3.48 0 0 0-3.24-2.17c-1.43 0-2.7.86-3.24 2.18 0 .02-.02.04-.03.07L96.3 43.82c-.58 1.51.18 3.2 1.7 3.78 1.51.58 3.2-.18 3.78-1.7m7.24-19.01 3.34 8.86h-6.72l3.37-8.86Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.43 16.52c-1.62 0-2.93 1.31-2.93 2.93v25.18a2.93 2.93 0 0 0 2.44 2.89c.21.04.38.06 3.16.06 1.35 0 3.3 0 6.17-.02 1.62 0 2.92-1.33 2.91-2.95 0-1.61-1.32-2.91-2.93-2.91h-.02c-2.03.01-4.21.02-5.88.02V19.45c0-1.62-1.31-2.93-2.93-2.93Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.33 43.18c-2.56.09-5.07-.87-6.7-2.55a2.934 2.934 0 0 0-4.14-.07 2.934 2.934 0 0 0-.07 4.14c2.65 2.74 6.59 4.34 10.6 4.34h.5c5.2-.17 9.46-3.63 10.12-8.21.5-3.44-1.21-7.87-7.52-9.96-3.17-1.05-6.12-2.21-6.99-2.56-.82-.59-.82-1.47-.78-1.84.05-.49.36-1.69 2.08-2.27 3.63-1.23 7.1 1.34 7.19 1.41A2.927 2.927 0 0 0 60.23 21c-.24-.19-5.97-4.6-12.67-2.34-3.36 1.13-5.67 3.89-6.04 7.18-.34 3.09 1.09 5.99 3.73 7.59.13.08.27.15.41.21.15.06 3.66 1.49 7.61 2.8 1.17.39 3.86 1.51 3.56 3.56-.22 1.51-1.97 3.11-4.52 3.2Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.61 62.37v12.95c0 2.89 2.35 5.24 5.24 5.24H50.8c1.4 0 2.72-.55 3.71-1.54a5.22 5.22 0 0 0 1.54-3.71V62.36c0-2.89-2.35-5.24-5.24-5.24H37.86c-2.89 0-5.24 2.35-5.24 5.24Zm5.86.61h11.72V74.7H38.47z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.81 62.63c0 1.62 1.31 2.93 2.93 2.93h59.01c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H68.74c-1.62 0-2.93 1.31-2.93 2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.74 77.53h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H68.74c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35 95.57c0-2.89-2.35-5.24-5.24-5.24H38.16c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54a5.22 5.22 0 0 0 1.54-3.71V95.56Zm-5.86 12.33H38.77V96.18h11.72z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.98 95.84c0-1.62-1.31-2.93-2.93-2.93H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h59.01c1.62 0 2.93-1.31 2.93-2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 104.87c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.35 128.77c0-2.89-2.35-5.24-5.24-5.24H38.16c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24h12.95c1.4 0 2.72-.55 3.71-1.54a5.22 5.22 0 0 0 1.54-3.71v-12.95Zm-5.86 12.34H38.77v-11.72h11.72z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.04 143.94h27.03c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1 156.73H38.15c-2.89 0-5.24 2.35-5.24 5.24v12.95c0 2.89 2.35 5.24 5.24 5.24H51.1c1.4 0 2.72-.55 3.71-1.54a5.22 5.22 0 0 0 1.54-3.71v-12.95c0-2.89-2.35-5.24-5.24-5.24Zm-.61 17.58H38.77v-11.72h11.72z",
    style: {
      fill: "url(#sla_svg2__l)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.07 177.14c1.62 0 2.93-1.31 2.93-2.93s-1.31-2.93-2.93-2.93H69.04c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.95 143.05a2.926 2.926 0 0 0-3.92-1.35 2.926 2.926 0 0 0-1.35 3.92c2.24 4.61 3.38 9.58 3.38 14.75 0 18.63-15.15 33.78-33.78 33.78s-33.79-15.15-33.79-33.78 15.16-33.78 33.79-33.78c8.48 0 16.59 3.16 22.84 8.89a2.936 2.936 0 0 0 4.14-.18 2.927 2.927 0 0 0-.18-4.14 39.5 39.5 0 0 0-23.87-10.31v-76.1h20.02c3.34 0 6.05-2.72 6.05-6.05V15.97c0-8.81-7.16-15.97-15.96-15.97H25.3c-6.74 0-12.23 5.48-12.23 12.23v39.42c0 1.62 1.31 2.93 2.93 2.93s2.93-1.31 2.93-2.93V12.23a6.38 6.38 0 0 1 6.37-6.37h122.66a15.87 15.87 0 0 0-3.62 10.11v104.87c-6.17.45-11.95 2.32-17.02 5.29H69.03c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h50.6c-7.17 6.98-11.71 16.64-11.99 27.34H69.03c-1.62 0-2.93 1.31-2.93 2.93s1.31 2.93 2.93 2.93h38.89c1.49 12.24 8.58 22.78 18.63 28.97H20.7c-.97 0-1.76-.79-1.76-1.76V65.33c0-1.62-1.31-2.93-2.93-2.93s-2.93 1.31-2.93 2.93V192.4c0 4.2 3.42 7.62 7.62 7.62h126.59c21.86 0 39.64-17.78 39.64-39.64 0-6.07-1.34-11.89-3.97-17.31ZM170.42 15.97V38.7a.2.2 0 0 1-.2.2H150.2V15.97c0-5.57 4.53-10.11 10.11-10.11s10.11 4.53 10.11 10.11",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.14 144.05-15.93 15.93-3.97-3.97a8.49 8.49 0 0 0-6.05-2.51h-.08c-2.32.02-4.48.95-6.09 2.62-3.22 3.34-3.11 8.77.24 12.13l7.38 7.38c2.15 2.15 4.94 3.44 7.83 3.61.24.01.47.02.71.02 3.16 0 6.2-1.25 8.43-3.49l19.75-19.75a8.5 8.5 0 0 0 2.51-6.13 8.5 8.5 0 0 0-2.62-6.09c-3.34-3.22-8.77-3.11-12.12.24Zm8.09 7.83-19.75 19.75c-1.24 1.24-2.89 1.86-4.65 1.76-1.46-.09-2.9-.76-4.04-1.9l-7.38-7.38c-1.11-1.11-1.18-2.86-.17-3.91.51-.53 1.19-.82 1.92-.83.73 0 1.42.27 1.93.79l5.42 5.42c.72.72 1.67 1.11 2.68 1.11s1.97-.39 2.68-1.11l17.38-17.39c1.11-1.11 2.86-1.18 3.91-.17.53.51.82 1.19.83 1.92 0 .73-.27 1.42-.79 1.93Z",
    style: {
      strokeWidth: 0,
      fill: "url(#sla_svg2__o)"
    }
  }));
};
export default SvgSla;